import {Component} from 'react';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import {PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip} from 'recharts';
import ptBR from 'date-fns/locale/pt-BR';

import http from 'services/http';
import formatMoney from 'utils/formatMoney';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.css';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658'];

export default class AnaliseCambista extends Component {
    constructor(props) {
        super(props);

        const hoje = new Date();

        this.state = {
            startDate: hoje,
            endDate: hoje,
            loading: false,
            dashboard: null,
            cambistaId: this.props.match.params.id
        };
    }

    handleDateChange = (dates) => {
        const [start, end] = dates;
        this.setState({startDate: start, endDate: end});
    };

    buscarAnalise = async (e) => {
        e.preventDefault();

        if (!this.state.startDate || !this.state.endDate) {
            return;
        }

        this.setState({loading: true});

        try {
            const response = await http.get(`/dashboard/cambista/${this.state.cambistaId}`, {
                params: {
                    data_inicial: dayjs(this.state.startDate).format('YYYY-MM-DD'),
                    data_final: dayjs(this.state.endDate).format('YYYY-MM-DD')
                }
            });

            this.setState({dashboard: response.data.data});
        } catch (error) {
            console.error('Erro ao buscar analise:', error);
        }

        this.setState({loading: false});
    };

    renderInformacaoGeral() {
        const {dashboard} = this.state;
        if (!dashboard?.informacao_geral) return null;

        const info = dashboard.informacao_geral;

        return (
            <div className={styles.cardSection}>
                <h3>Informacoes Gerais</h3>
                <div className={styles.cardsGrid}>
                    <div className={styles.card}>
                        <span className={styles.cardLabel}>Ultima Aposta</span>
                        <span className={styles.cardValue}>
                            {info.ultima_aposta ? dayjs(info.ultima_aposta).format('DD/MM/YY HH:mm') : '-'}
                        </span>
                    </div>
                    <div className={styles.card}>
                        <span className={styles.cardLabel}>Qtd. Apostas</span>
                        <span className={styles.cardValue}>{info.quantidade_apostas}</span>
                    </div>
                    <div className={styles.card}>
                        <span className={styles.cardLabel}>Qtd. em Aberto</span>
                        <span className={styles.cardValue}>{info.quantidade_aberta}</span>
                    </div>
                    <div className={styles.card}>
                        <span className={styles.cardLabel}>Ticket Medio</span>
                        <span className={styles.cardValue}>{formatMoney(info.ticket_medio)}</span>
                    </div>
                </div>

                <div className={styles.resumoGrid}>
                    <div className={`${styles.resumoCard} ${styles.entrada}`}>
                        <span className={styles.resumoLabel}>Entrada</span>
                        <span className={styles.resumoValor}>{formatMoney(info.entrada)}</span>
                    </div>
                    <div className={`${styles.resumoCard} ${styles.premios}`}>
                        <span className={styles.resumoLabel}>Premios</span>
                        <span className={styles.resumoValor}>{formatMoney(info.premios)}</span>
                    </div>
                    <div className={`${styles.resumoCard} ${styles.comissao}`}>
                        <span className={styles.resumoLabel}>Comissao</span>
                        <span className={styles.resumoValor}>{formatMoney(info.comissao)}</span>
                    </div>
                    <div className={`${styles.resumoCard} ${styles.total} ${info.total >= 0 ? styles.positivo : styles.negativo}`}>
                        <span className={styles.resumoLabel}>Total</span>
                        <span className={styles.resumoValor}>{formatMoney(info.total)}</span>
                    </div>
                </div>
            </div>
        );
    }

    renderGraficoPizza(titulo, dados, nameKey = 'modalidade') {
        if (!dados || dados.length === 0) return null;

        return (
            <div className={styles.chartCard}>
                <h4>{titulo}</h4>
                <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                        <Pie
                            data={dados}
                            dataKey="valor"
                            nameKey={nameKey}
                            cx="50%"
                            cy="45%"
                            outerRadius={75}
                            innerRadius={35}
                        >
                            {dados.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                            ))}
                        </Pie>
                        <Tooltip formatter={(value) => formatMoney(value)}/>
                        <Legend iconType="circle" iconSize={10}/>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    }

    renderGraficoExtracoes() {
        const {dashboard} = this.state;
        if (!dashboard?.extracoes_mais_jogadas) return null;

        const dados = dashboard.extracoes_mais_jogadas.map(item => ({
            modalidade: item.nome,
            valor: item.valor
        }));

        return this.renderGraficoPizza('Extracoes Mais Jogadas', dados);
    }

    renderTopNumeros(titulo, dados) {
        if (!dados || dados.length === 0) return null;

        return (
            <div className={styles.topCard}>
                <h4>{titulo}</h4>
                <div className={styles.numerosRow}>
                    {dados.map((item, index) => (
                        <div key={index} className={styles.numeroCard}>
                            <span className={styles.numeroQtd}>{item.quantidade}x</span>
                            <span className={styles.numeroValor}>{item.numero}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        const {dashboard, loading, startDate, endDate} = this.state;
        const nomeCambista = dashboard?.informacao_geral?.nome;

        return (
            <>
                <div className="titulo-principal">
                    Analise {nomeCambista ? `- ${nomeCambista}` : 'do Cambista'}
                </div>
                <div className="conteudo-principal">
                    <form onSubmit={this.buscarAnalise} className="d-flex duas-colunas">
                        <div className={styles.datePickerWrapper}>
                            <label>Periodo</label>
                            <DatePicker
                                selected={startDate}
                                onChange={this.handleDateChange}
                                startDate={startDate}
                                endDate={endDate}
                                selectsRange
                                dateFormat="dd/MM/yyyy"
                                locale={ptBR}
                                className="form-control"
                                placeholderText="Selecione o periodo"
                            />
                        </div>
                        <div style={{alignSelf: 'flex-end'}}>
                            <button type="submit" className="btn btn-primary" style={{height: '38px'}}>
                                Buscar
                            </button>
                        </div>
                    </form>
                </div>

                {loading ? (
                    <>
                        <p>Carregando analise do cambista...</p>
                        <div className="loader"/>
                    </>
                ) : dashboard && (
                    <div className={styles.dashboardContent}>
                        {this.renderInformacaoGeral()}

                        <div className={styles.chartsRow}>
                            {this.renderGraficoPizza('Modalidades Mais Jogadas', dashboard.modalidades_mais_jogadas)}
                            {this.renderGraficoExtracoes()}
                        </div>

                        <div className={styles.topNumerosGrid}>
                            {this.renderTopNumeros('Top 5 Milhares', dashboard.top_milhares)}
                            {this.renderTopNumeros('Top 5 Centenas', dashboard.top_centenas)}
                            {this.renderTopNumeros('Top 5 Dezenas', dashboard.top_dezenas)}
                            {this.renderTopNumeros('Top 5 Grupos', dashboard.top_grupos)}
                        </div>
                    </div>
                )}
            </>
        );
    }
}
